'use client'

import { useEffect, useRef } from 'react'
import { trackPricingViewed } from '@/lib/site/gtm'

type PricingPageViewTrackerProps = {
  userId?: string | null
  orgId?: string | null
  currentPlan?: string | null
  usagePercent?: number | null
}

/**
 * Fires `brew_pricing_viewed` exactly once per mount. Use on every
 * surface that shows pricing — both the public marketing pricing page
 * and the in-app `/plan` billing page — so GTM has a uniform signal
 * for "user considered upgrading."
 */
export function PricingPageViewTracker({
  userId,
  orgId,
  currentPlan,
  usagePercent,
}: PricingPageViewTrackerProps) {
  const firedRef = useRef(false)

  useEffect(() => {
    if (firedRef.current) {
      return
    }
    firedRef.current = true

    trackPricingViewed({
      user_id: userId ?? undefined,
      org_id: orgId ?? undefined,
      current_plan: currentPlan ?? 'free',
      usage_percent:
        typeof usagePercent === 'number' && Number.isFinite(usagePercent)
          ? usagePercent
          : 0,
    })
  }, [userId, orgId, currentPlan, usagePercent])

  return null
}
